import React from "react";
import { useAuth } from "./AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import Preloader from "../Components/Preloader";

const PrivateRoute: React.FC = () => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <Preloader />
        );
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" />;

}

export default PrivateRoute;
